export default __webpack_public_path__ + "static/media/scrap.a90aa1ae.jpg";